import gql from 'graphql-tag';

export default gql`
  subscription onCreateItem {
    onCreateItem {
      id
      title
      price
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/subscriptions/NewItemSubscription.ts